import React from "react";
import { Box } from "@mui/material";
import { StatusChip } from "@akj-dev/shared-components";

interface CreateIdCheckTaskStatusProps {
  isFetching: boolean;
  isSuccess: boolean;
  isError: boolean;
  successMessage?: string;
  errorMessage?: string;
}

export const CreateIdCheckTaskStatus = ({
  isFetching,
  isSuccess,
  isError,
  successMessage,
  errorMessage,
}: CreateIdCheckTaskStatusProps) => {
  if (isFetching)
    return (
      <Box mb={1}>
        <StatusChip
          title="Checking ID check task status"
          message="Please wait..."
          type="loading"
        />
      </Box>
    );
  if (isSuccess && !successMessage)
    return (
      <Box mb={1}>
        <StatusChip message="ID check task created" type="success" />
      </Box>
    );
  if (isSuccess && successMessage)
    return (
      <Box mb={1}>
        <StatusChip message={successMessage} type="info" />
      </Box>
    );
  if (isError && !errorMessage)
    return (
      <Box mb={1}>
        <StatusChip title="Error checking ID check task status" type="error" />
      </Box>
    );
  if (isError && errorMessage)
    return (
      <Box mb={1}>
        <StatusChip
          title="Error checking ID check task status"
          message={errorMessage}
          type="error"
        />
      </Box>
    );
  return null;
};
